//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function Midnight() {

    return (
        <>

        <p>I used to see a girl from Vegas<br></br>
        Her hair was dark and demeanour was audacious<br></br>
        Had me smiling like a kid<br></br>
        Used to go meet her round the back of the pyramid<br></br>
        I was hooked (I know)<br></br>
        Devil's advocate is playing on the stereo<br></br>
        Took a cab off the metre<br></br>
        Had to go through hell when I see her<br></br>
        <br></br>
        A glint in her eye from the neon sign<br></br>
        We used to have the wildest time<br></br>
        But I knew I wanted more<br></br>
        Than the keys to your hotel door<br></br>
        <br></br>
        Always tried to replace you<br></br>
        With every pleasure of mine<br></br>
        But all I got was a breakthrough<br></br>
        The suns too heavy to rise in this sky<br></br>
        Feels like midnight<br></br>
        <br></br>
        How could I forget when<br></br>
        <br></br>
        You burnt a hole in my mind<br></br>
        Kept the motor running when you parked outside<br></br>
        At the fountain of youth<br></br>
        Deep in the ways of the low hanging fruit<br></br>
        <br></br>
        Caught me drinking pareidolia<br></br>
        When I saw your face in a getaway brochure<br></br>
        Away from the glorious sunlight<br></br>
        Another world at midnight<br></br>
        <br></br>
        Why’d you come looking for answers<br></br>
        When you dance around the question<br></br>
        Don’t you know that there’s no going back, going back<br></br>
        <br></br>
        Karmas asking for your name in the rain shadow<br></br>
        Ecstasy won’t call you back once the debts been settled<br></br>
        What's a crown to a queen on the other side?<br></br>
        When half the day becomes the night<br></br>
        <br></br>
        Always tried to replace you<br></br>
        With every pleasure of mine<br></br>
        But all I got was a breakthrough<br></br>
        The suns too heavy to rise in this sky<br></br>
        <br></br>
        Always tried to replace you<br></br>
        With every pleasure of mine<br></br>
        But all I got was a breakthrough<br></br>
        The suns too heavy to rise in this sky<br></br>
        <br></br>
        A glint in her eye from the neon sign<br></br>
        We used to have the wildest time<br></br>
        But I knew I wanted more<br></br>
        Than the keys to your hotel door</p>
        
        </> 
    )
}